<div class="audio-waverform" [ngClass]="theme">
  @if (init) {
    <lib-icon [icon]="isPlaying ? 'pause' : 'play'" (click)="togglePlay()" class="play-icon"></lib-icon>
  } @else {
    <mat-spinner [diameter]="16"></mat-spinner>
  }

  <div #waveform class="audio-wave" [class.init]="init">
    <div class="audio-wave-placeholder"></div>
  </div>

  <span>{{ duration  | secondsToTime }} </span>
</div>

